import {asyncType} from '../helpers';

export const partnersReducerKey = 'partners';

export default {
   GET_PARTNER: asyncType(`${partnersReducerKey}/GET_PARTNER`),
   CREATE_PARTNER: asyncType(`${partnersReducerKey}/CREATE_PARTNER`),
   MOVE_PARTNER: asyncType(`${partnersReducerKey}/MOVE_PARTNER`),
   GET_REFS_PGP: asyncType(`${partnersReducerKey}/GET_REFS_PGP`),
   GET_REFS_SSH: asyncType(`${partnersReducerKey}/GET_REFS_SSH`),
   GET_REFS_SSL: asyncType(`${partnersReducerKey}/GET_REFS_PGP`),
   GET_REFS_PROXY: asyncType(`${partnersReducerKey}/GET_REFS_PROXY`),
   RELEASE_PARTNER: `${partnersReducerKey}/RELEASE_PARTNER`,
   SUSPEND_PARTNER: `${partnersReducerKey}/SUSPEND_PARTNER`,
};
